
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";

import RealTimePriceLoadingState from "@dana/Store/Data/RealTimePriceLoading/RealTimePriceLoadingState";
import { Draft } from "immer";

const initialState: RealTimePriceLoadingState = {
    isLoading: false,
};

const realTimePriceLoadingStateImmerReducer = createTypedReducerWithImmer(initialState, {

    "RealTimePrice/IsLoading": (draft: Draft<RealTimePriceLoadingState>, action: { isLoading: boolean }) => {
        draft = { ...draft, isLoading: action.isLoading };
        return draft;
    },

});

(reducers as any).realTimePriceLoading = realTimePriceLoadingStateImmerReducer;

type RealTimePriceLoadingReducers = {
    realTimePriceLoading: typeof realTimePriceLoadingStateImmerReducer;
};

export type RealTimePriceLoadingActions = Parameters<RealTimePriceLoadingReducers[keyof RealTimePriceLoadingReducers]>[1] | AnyAction;

